<template>
    <div id="contenedor-licitaciones-main">
      <keep-alive include="LicitacionesDefault">
        <router-view></router-view>
      </keep-alive>
    </div>
</template>

<script>
export default {
  name: 'LicitacionesMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
